import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const NumberTemplateStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "number-template",
})<{ $hasRightIcon: boolean }>`
  position: relative;
  width: 100%;
  overflow: visible;
`;
